import React, { Component } from 'react'
import { connect } from 'react-redux'
import Select from 'react-select'

class PaymentStatusFilter extends Component {
  componentDidMount() {
    this.props.dispatch({ type: 'FETCH_INTERVIEW_PAYMENT_STATUS_REQUESTED' })
  }

  render() {
    const allOption = { value: 'ALL', label: 'All' }
    const options = [
      allOption,
      ...(this.props.paymentStatusList || []).map(status => ({
        value: status.code,
        label: status.display
      }))
    ]
    const selectedOption = options.find(option => option.value === this.props.selectedOption) || allOption

    return (
      <div className="payment-status-filter">
        <label className="text control-label">Rewards Status</label>
        <Select
          closeOnSelect={true}
          searchable={false}
          clearable={false}
          options={options}
          value={selectedOption}
          className="status-dropdown"
          onChange={this.props.onChange}
          placeholder="Payment Status"
        />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  paymentStatusList: state.interviewPaymentStatusList.paymentStatusList
})

export default connect(mapStateToProps)(PaymentStatusFilter)

